<template>
    <div :class="style.productEditPage">
        <product-price-setting-table :productId="productId"/>
    </div>
</template>

<script>
    import Vue from 'vue'
    import productPriceSettingTable from '@/components/root-components/product-price-setting/product-price-setting-table.vue'
    // import modal from '@/components/common/modal/modal'
    // import modalWorkboard from '@/components/common/modal/modal-workboard'
    import style from './style.module.scss'

    export default Vue.extend({
        name: 'product-edit-page',
        components: {
            productPriceSettingTable,
            // modal,
            // modalWorkboard
        },
        props: {
            
        },
        data() {
            return {
                style: style,
                gridShow: false,
                productId: this.$root.productId ? this.$root.productId : null
            }
        },
        mounted(){
            window.productEditPageEventBus.$on("setUnitName", (currentUnitName) => {
                this.$store.dispatch('setUnitName', { unitName: currentUnitName })
            })
        }
    })
</script>